if (!customElements.get('kurta-size-guide-drawer')) {
  class KurtaSizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('modal-dialog').then(() => this.moveInlineChart());
    }

    moveInlineChart() {
      const productForm = this.closest('product-form');
      const description = productForm?.querySelector('.product-details__description');
      const modal = this.querySelector('modal-dialog');
      const drawerContent = this.querySelector('[data-kurta-size-guide-content]');

      if (!productForm || !description || !modal || !drawerContent) return;

      this.initUnitToggle(drawerContent);

      const chartHeading = Array.from(description.children).find((element) => {
        const heading = element.matches('h1, h2, h3, h4, h5, h6') ? element : element.querySelector('h1, h2, h3, h4, h5, h6');
        return heading && /^(size chart|size guide)$/i.test(heading.textContent.trim());
      });

      if (!chartHeading) return;

      let chartNode = chartHeading;
      while (chartNode) {
        const nextNode = chartNode.nextSibling;
        chartNode.remove();
        chartNode = nextNode;
      }

      productForm.querySelectorAll('.size-chart-link').forEach((link) => {
        const trigger = link.closest('open-or-scroll-to');
        if (trigger) trigger.dataset.targetId = modal.id;
        link.setAttribute('aria-haspopup', 'dialog');
      });
    }

    initUnitToggle(drawerContent) {
      const buttons = drawerContent.querySelectorAll('.kurta-size-guide__unit button');
      const measurementCells = drawerContent.querySelectorAll('.kurta-size-guide__table tbody td:not(:first-child)');

      measurementCells.forEach((cell) => {
        cell.dataset.centimetres = parseFloat(cell.textContent);
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const useCentimetres = button.textContent.trim() === 'cm';

          buttons.forEach((unitButton) => {
            const isSelected = unitButton === button;
            unitButton.classList.toggle('is-active', isSelected);
            unitButton.setAttribute('aria-pressed', isSelected);
          });

          measurementCells.forEach((cell) => {
            const centimetres = Number(cell.dataset.centimetres);
            cell.textContent = useCentimetres
              ? `${centimetres} cm`
              : `${(centimetres / 2.54).toFixed(1)} in`;
          });
        });
      });
    }
  }

  customElements.define('kurta-size-guide-drawer', KurtaSizeGuideDrawer);
}
